import { useContext } from 'react'
import VideoContext from './VideoContext'

export const useVideoContext = <VideoContextProps>() =>
  useContext(VideoContext) as VideoContextProps
